import { z } from "zod";
import { AdvisorId, DateSchema, FeedId } from "../Types";
export const FeedStatus = z.enum(["READ", "UNREAD", "ARCHIVED"]);
export const FeedData = z.object({
    subject: z.string().nullable(),
    body: z.string(),
    url: z.string().nullable(),
});
export const FeedMetadata = z.object({
    source: z.string(),
    referenceId: z.string().uuid(),
    attributes: z
        .array(z.object({
        key: z.string(),
        value: z.string(),
    }))
        .nullable(),
});
export const Feed = z.object({
    feedId: FeedId,
    personId: AdvisorId,
    status: FeedStatus,
    data: FeedData,
    metadata: FeedMetadata,
    createdTs: DateSchema,
    updatedTs: DateSchema,
});
export const FeedV2 = Feed.extend({
    resourceType: z.string(),
    resourceId: z.string(),
});
//# sourceMappingURL=Types.js.map